/**
 * N.B. type used to provide accurate typing of object lookup
 * e.g. const a: Record<string, number> = {}; const b = a['k'];
 * b is incorrectly typed as number instead of number | undefined
 */
export function safeObjGet<T>(val: T): T | undefined {
  return val;
}

export function isNotNull<T>(value: T): value is NonNullable<T> {
  return value != null;
}

export function isNull<T>(value: T): value is NonNullable<T> {
  return value == null;
}

export function nullSafeEqual<T>(lhs: T | null | undefined, rhs: T | null | undefined) {
  return (lhs ?? null) === (rhs ?? null);
}

/**
 * Can be used in switch statements, for example, to assert that the default case
 * should never be reached and all switch cases should be accounted for.  This will
 * be caught at compile time.
 */
export function assertUnreachable(_: never): never {
  // This error should theoretically not be hit at runtime, since it should be caught by TS.
  throw new Error('Unreachable code hit. This should be caught at compile time.');
}

export function assertDefined<T>(value: T): asserts value is NonNullable<T> {
  if (value == null) {
    throw new Error('Value is not defined');
  }
}
